export default "__VITE_ASSET__BCyd7vib__"